// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"f5fd77db","232":"f5fd77db","405":"f5fd77db","581":"f5fd77db"}[chunkId] + ".chunk.css";
};